import React, { useContext } from 'react';
import { useFetch } from '../../data/fetch/useFetch';
import { parseAutocompleteData } from '../../data/parseAutocompleteData';
import { getConfiguration } from '../../data/utils/configuration';
import Loader from '.././Loader';
import StickyHeader from '../StickyHeader';

export const SearchDataContext = React.createContext(null);

export function useSearchData() {
    return useContext(SearchDataContext);
}

export default function SearchDataProvider(props) {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getAutocompleteData, { live: false }, (data) =>
        parseAutocompleteData(data, false)
    );

    if (isLoading || isError) {
        return (
            <>
                <StickyHeader></StickyHeader>
                <div className="w-full h-full flex items-center justify-center">
                    <Loader error={isError} centered={true} />
                </div>
            </>
        );
    }

    return (
        <SearchDataContext.Provider value={data}>
            {props.children}
        </SearchDataContext.Provider>
    );
}
